import StaticPageLayout from "@/components/layout/StaticPageLayout";
import { useLanguage } from "@/context/LanguageContext";

export default function About() {
  const { language } = useLanguage();

  const contentEn = (
    <div className="space-y-6 text-sm text-muted-foreground leading-relaxed">
      <section className="space-y-3">
        <h2 className="text-xl font-bold text-[#2A0A10]">Our Vision & Philosophy</h2>
        <p>
          Hamarsathi was founded with a profound vision: to bring simplicity, trust, and absolute local relevance to the matchmaking process for the families of Jharkhand. Traditional matrimonial sites are often massive, impersonal, and fail to cater to regional requirements. We believe that finding a life partner is a deeply personal milestone, and the technology enabling it should be just as precise and cultural.
        </p>
        <p>
          Our platform focuses exclusively on Jharkhand’s 24 districts, helping candidates find matches within their immediate cultural, geographical, and linguistic environments.
        </p>
      </section>

      <section className="space-y-3">
        <h2 className="text-xl font-bold text-[#2A0A10]">Why We are Different (District-First Approach)</h2>
        <p>
          Unlike generic websites, Hamarsathi features localized search filters down to the district, block, and village level. We recognize that communities in Jharkhand have unique traditions, dialects, and social fabrics. Whether you are searching in Ranchi, Jamshedpur, Hazaribagh, Dhanbad, Deoghar, or in rural areas like Jaldega or Ichak, our platform maps these distinctions to provide highly relevant suggestions.
        </p>
      </section>

      <section className="space-y-3">
        <h2 className="text-xl font-bold text-[#2A0A10]">Our Core Pillars</h2>
        <div className="grid md:grid-cols-3 gap-4 mt-2">
          <div className="bg-slate-50 border border-slate-200/60 p-4 rounded-xl">
            <h4 className="font-bold text-[#2A0A10] mb-1">100% Verified Profiles</h4>
            <p className="text-xs">We enforce verification through government ID uploads and Selfie-based verification to ensure absolute authenticity.</p>
          </div>
          <div className="bg-slate-50 border border-slate-200/60 p-4 rounded-xl">
            <h4 className="font-bold text-[#2A0A10] mb-1">Privacy & Consent</h4>
            <p className="text-xs">Full privacy controls allow members to hide their photos, hide phone numbers, and approve contact requests on their terms.</p>
          </div>
          <div className="bg-slate-50 border border-slate-200/60 p-4 rounded-xl">
            <h4 className="font-bold text-[#2A0A10] mb-1">JharkhandVivah Mitra network</h4>
            <p className="text-xs">A local network of district ambassadors helps rural and semi-urban families register, match, and verify connections locally.</p>
          </div>
        </div>
      </section>

      <section className="space-y-3">
        <h2 className="text-xl font-bold text-[#2A0A10]">Technology Meets Tradition</h2>
        <p>
          We blend state-of-the-art matchmaking algorithms with traditional needs, such as a built-in automated Kundli Matching system and detailed caste/community categorization tailored to Jharkhand. Our goal is not just matching profiles, but uniting families with security, respect, and dignity.
        </p>
      </section>
    </div>
  );

  const contentHi = (
    <div className="space-y-6 text-sm text-muted-foreground leading-relaxed">
      <section className="space-y-3">
        <h2 className="text-xl font-bold text-[#2A0A10]">हमारा दृष्टिकोण और दर्शन</h2>
        <p>
          हमरसाथी की स्थापना एक गहरे दृष्टिकोण के साथ की गई थी: झारखंड के परिवारों के लिए जीवनसाथी खोजने की प्रक्रिया में सादगी, विश्वास और पूर्ण स्थानीय प्रासंगिकता लाना। पारंपरिक वैवाहिक साइटें अक्सर बहुत बड़ी, व्यक्तिगत भावना से रहित होती हैं और क्षेत्रीय आवश्यकताओं को पूरा करने में विफल रहती हैं। हमारा मानना है कि जीवनसाथी खोजना एक अत्यंत व्यक्तिगत मील का पत्थर है, और इसे सक्षम बनाने वाली तकनीक भी उतनी ही सटीक और सांस्कृतिक होनी चाहिए।
        </p>
        <p>
          हमारा मंच विशेष रूप से झारखंड के 24 जिलों पर ध्यान केंद्रित करता है, जिससे उम्मीदवारों को उनके स्थानीय सांस्कृतिक, भौगोलिक और भाषाई परिवेश के भीतर मैच खोजने में मदद मिलती है।
        </p>
      </section>

      <section className="space-y-3">
        <h2 className="text-xl font-bold text-[#2A0A10]">हम अलग क्यों हैं (जिला-प्रथम दृष्टिकोण)</h2>
        <p>
          सामान्य वेबसाइटों के विपरीत, हमरसाथी में जिला, ब्लॉक और ग्राम स्तर तक स्थानीय खोज फ़िल्टर शामिल हैं। हम जानते हैं कि झारखंड में समुदायों की अपनी अनूठी परंपराएं, बोलियां और सामाजिक ताने-बाने हैं। चाहे आप रांची, जमशेदपुर, हजारीबाग, धनबाद, देवघर में खोज रहे हों या जलडेगा या इचाक जैसे ग्रामीण क्षेत्रों में, हमारा मंच इन अंतरों को समझकर सही सुझाव देता है।
        </p>
      </section>

      <section className="space-y-3">
        <h2 className="text-xl font-bold text-[#2A0A10]">हमारे मुख्य आधार स्तंभ</h2>
        <div className="grid md:grid-cols-3 gap-4 mt-2">
          <div className="bg-slate-50 border border-slate-200/60 p-4 rounded-xl">
            <h4 className="font-bold text-[#2A0A10] mb-1">100% सत्यापित प्रोफाइल</h4>
            <p className="text-xs">हम पूर्ण प्रामाणिकता सुनिश्चित करने के लिए सरकारी आईडी अपलोड और सेल्फी-आधारित सत्यापन लागू करते हैं।</p>
          </div>
          <div className="bg-slate-50 border border-slate-200/60 p-4 rounded-xl">
            <h4 className="font-bold text-[#2A0A10] mb-1">गोपनीयता और सहमति</h4>
            <p className="text-xs">पूर्ण गोपनीयता नियंत्रण सदस्यों को अपनी तस्वीरें छिपाने, फोन नंबर छिपाने और सहमति पर ही बातचीत करने की अनुमति देते हैं।</p>
          </div>
          <div className="bg-slate-50 border border-slate-200/60 p-4 rounded-xl">
            <h4 className="font-bold text-[#2A0A10] mb-1">विवाह मित्र नेटवर्क</h4>
            <p className="text-xs">जिला राजदूतों का एक स्थानीय नेटवर्क ग्रामीण और अर्ध-शहरी परिवारों को स्थानीय स्तर पर पंजीकरण, मिलान और सत्यापन में मदद करता है।</p>
          </div>
        </div>
      </section>

      <section className="space-y-3">
        <h2 className="text-xl font-bold text-[#2A0A10]">पारंपरिक आवश्यकता और आधुनिक तकनीक</h2>
        <p>
          हम आधुनिक मिलान एल्गोरिदम को पारंपरिक आवश्यकताओं जैसे कि स्वचालित कुंडली मिलान और झारखंड के लिए तैयार की गई विस्तृत जाति/समुदाय श्रेणियों के साथ जोड़ते हैं। हमारा लक्ष्य केवल प्रोफाइल का मिलान करना नहीं है, बल्कि सुरक्षा, सम्मान और गरिमा के साथ परिवारों को जोड़ना है।
        </p>
      </section>
    </div>
  );

  return (
    <StaticPageLayout
      title={language === "hi" ? "हमारे बारे में" : "About Us"}
      subtitle={language === "hi" ? "झारखंड का सबसे भरोसेमंद मैट्रिमोनी मंच" : "Jharkhand's most trusted matrimony platform"}
    >
      {language === "hi" ? contentHi : contentEn}
    </StaticPageLayout>
  );
}
